import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/home' },
    { name: 'About', path: '/about' },
    { name: 'Locations', path: '/locations' },
    { name: 'Properties', path: '/properties' },
    { name: 'Rules', path: '/rules' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/home" className="flex items-center" data-testid="nav-logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_c19329c1-9bab-43aa-9723-765360d28c48/artifacts/deynhimw_indweller%20stay%20logo%20final.png" 
              alt="INDWELLER STAY Logo" 
              className="h-12"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`font-body text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-brand-purple'
                    : 'text-gray-700 hover:text-brand-purple'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/inquiry"
              data-testid="nav-inquiry-button"
              className="bg-brand-purple text-white px-6 py-2 rounded-full font-body font-medium hover:bg-opacity-90 transition-all shadow-lg shadow-purple-900/20 hover:shadow-xl hover:shadow-purple-900/30"
            >
              Inquire Now
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700"
            data-testid="nav-hamburger-button"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-100"
            data-testid="nav-mobile-menu"
          >
            <div className="px-4 py-4 space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  data-testid={`nav-mobile-link-${link.name.toLowerCase()}`}
                  className={`block py-2 px-4 rounded-lg font-body transition-colors ${
                    isActive(link.path)
                      ? 'bg-brand-purple/10 text-brand-purple font-medium'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/inquiry"
                onClick={() => setIsOpen(false)}
                data-testid="nav-mobile-inquiry-button"
                className="block bg-brand-purple text-white px-4 py-2 rounded-full font-body font-medium text-center hover:bg-opacity-90 transition-all"
              >
                Inquire Now
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
